/// <amd-module name="typeahead/core/logging/DctkClientLogErrorTransport"/>

/// <reference path="../../../typings/typeahead/clientLogging.d.ts"/>
/// <reference path="../../../typings/typeahead/modulizr.d.ts" />
/// <reference path="../../../typings/thirdparty/underscore/index.d.ts" />

import * as _ from "underscore";

import {IClientLogging} from "dctk/clientLogging";
import {IErrorTransport} from "typeahead/core/logging/ErrorTransport";
import {ProblemOrigin} from "typeahead/core/logging/ProblemOrigin";
import {Severity} from "typeahead/core/logging/Severity";

export class DctkClientLogErrorTransport implements IErrorTransport {
    private clientLogger: IClientLogging;
    public log(e: Error, severity: Severity, origin: ProblemOrigin, additional: any = {}): void {
        try {
            if (! _.isObject(additional)) {
                const tmp = additional;
                additional = {};
                additional.additional_info = tmp;
            }
            additional.severity = Severity[severity];
            additional.problemOrigin = ProblemOrigin[origin];

            // Inline require is being done so that this module creation does not fail in case the client does not use
            // clientLogging.js.
            if (!this.clientLogger) {
                require(["dctk/clientLogging", "dctk/dctk"], (cl, dctk) => {
                    this.clientLogger = cl;
                    this.doClientLogging(e, severity, additional);
                });
            } else {
                this.doClientLogging(e, severity, additional);
            }
        } catch (e) {
            // Ignore
        }
    }

    private doClientLogging(e: Error, severity: Severity, additional: any): void {
        if (this.clientLogger) {
            if (Severity.MustFix === severity) {
                this.clientLogger.logError("UniversalTypeahead", e, additional);
            } else {
                if (e) {
                    additional.message = e.message;
                    additional.name = e.name;
                    additional.stack = e.stack;
                }
                this.clientLogger.logMessage("UniversalTypeahead", additional);
            }
        } else {
            if (console && _.isFunction(console.error)) {
                console.error(e);
            }
        }
    }
}
